import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { auth } from '../utils/auth';
import { useLanguage } from '../i18n';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const AdminLogin = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!RECAPTCHA_SITE_KEY) return;
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
      const badge = document.querySelector('.grecaptcha-badge');
      if (badge) badge.remove();
    };
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      let recaptchaToken = null;
      if (window.grecaptcha && RECAPTCHA_SITE_KEY) {
        try {
          recaptchaToken = await new Promise((resolve, reject) => {
            window.grecaptcha.ready(() => {
              window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'admin_login' })
                .then(resolve)
                .catch(reject);
            });
          });
        } catch (_) { /* reCAPTCHA not critical */ }
      }

      await auth.login(credentials.username, credentials.password, recaptchaToken);
      toast.success(t('toastLoginSuccess'));
      navigate('/admin/dashboard');
    } catch (error) {
      const detail = error.response?.data?.detail || 'Login fehlgeschlagen. Bitte überprüfen Sie Ihre Zugangsdaten.';
      toast.error(detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="calculator-container" data-testid="admin-login-page">
      <div className="calculator-card" style={{ maxWidth: '500px' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img
            src="https://customer-assets.emergentagent.com/job_lead-wizard-5/artifacts/xohrqn39_Logo%20separatus%20vergleich.png"
            alt="separatus Vergleich"
            style={{ maxWidth: '250px', marginBottom: '1.5rem' }}
            data-testid="admin-logo"
          />
          <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#1B5E20' }}>Admin Login</h2>
        </div>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label className="form-label">Benutzername oder E-Mail</label>
            <input
              type="text"
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              className="form-input"
              placeholder="Benutzername oder E-Mail"
              required
              data-testid="username-input"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Passwort</label>
            <input
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              className="form-input"
              required
              data-testid="password-input"
            />
          </div>
          <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading} data-testid="login-btn">
            {loading ? 'Anmelden...' : 'Anmelden'}
          </button>
        </form>
        <p style={{ textAlign: 'center', fontSize: '0.7rem', color: '#999', marginTop: '1.5rem' }}>
          Geschützt durch reCAPTCHA
        </p>
        <div style={{ textAlign: 'center', marginTop: '0.5rem' }}>
          <button onClick={() => navigate('/')} className="btn-secondary" data-testid="back-home-btn">
            Zurück zur Startseite
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
